import React, { useState, useEffect, useCallback } from 'react';
import api from '../../apiClient';
import './AvaliacaoSolicitante.css';

// Avaliação de satisfação (CSAT 1-5) no fechamento — portal do solicitante (Fase 8).
function AvaliacaoSolicitante({ satNum }) {
  const [nota, setNota] = useState(0);
  const [hover, setHover] = useState(0);
  const [comentario, setComentario] = useState('');
  const [existente, setExistente] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = useCallback(async () => {
    if (!satNum) return;
    try {
      const res = await api.get('/api/avaliacao/' + satNum);
      if (res && res.data) { setExistente(res.data); setNota(res.data.nota || 0); setComentario(res.data.comentario || ''); }
    } catch (_) {}
  }, [satNum]);

  useEffect(() => { carregar(); }, [carregar]);

  if (!satNum) return null;

  const enviar = async () => {
    setErro('');
    if (nota < 1) { setErro('Escolha de 1 a 5 estrelas.'); return; }
    setSalvando(true);
    try {
      await api.post('/api/avaliacao/' + satNum, { tipo: 'CSAT', nota, comentario });
      setEnviado(true);
      setExistente({ nota, comentario, tipo: 'CSAT' });
    } catch (e) {
      setErro(e?.response?.data?.error || 'Não foi possível enviar a avaliação.');
    } finally {
      setSalvando(false);
    }
  };

  const jaAvaliado = existente && !enviado;

  return (
    <section className="sol-card aval-card">
      <h2 className="hist-fechada-card-title"><i className="fas fa-star" /> Avaliação do atendimento</h2>
      {enviado && <div className="aval-ok">Obrigado pela sua avaliação!</div>}
      {jaAvaliado && <div className="aval-info">Você já avaliou este atendimento. Pode atualizar abaixo se quiser.</div>}

      <div className="aval-estrelas" role="radiogroup" aria-label="Nota de 1 a 5">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            className={`aval-estrela ${(hover || nota) >= n ? 'ativa' : ''}`}
            onMouseEnter={() => setHover(n)}
            onMouseLeave={() => setHover(0)}
            onClick={() => setNota(n)}
            aria-label={`${n} estrela${n > 1 ? 's' : ''}`}
          >
            <i className="fas fa-star" />
          </button>
        ))}
      </div>

      <textarea
        className="aval-coment"
        placeholder="Comentário (opcional)"
        value={comentario}
        maxLength={1000}
        onChange={(e) => setComentario(e.target.value)}
      />

      {erro && <div className="aval-erro">{erro}</div>}

      <button type="button" className="sol-btn" onClick={enviar} disabled={salvando}>
        {salvando ? 'Enviando…' : (existente ? 'Atualizar avaliação' : 'Enviar avaliação')}
      </button>
    </section>
  );
}

export default AvaliacaoSolicitante;
